import { Currency } from '~client/model/currency';

/**
 * Returns an array of supported currencies
 */
export const getSupportedCurrencies = (): Currency[] => [Currency.USD, Currency.CAD];



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/helper/currency.ts